import {Component, ViewChild, Input, Output, EventEmitter, ViewContainerRef, ComponentFactory, ComponentRef, ComponentFactoryResolver, AfterViewInit} from '@angular/core';
import {LocationStrategy} from '@angular/common';
import {AppService} from '@api';
import {HeaderEnum, RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {SistemaService} from '@servicios/Sistema.Service';
import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {Pregunta} from '@modelo/proceso/Pregunta.model';
import {RelacionPreguntaComponent} from '../../global/relacionpregunta/relacionPregunta.component';


@Component({
    selector: 'preguntaForm',
    templateUrl: './preguntaForm.component.html',
    styleUrls: ['./pregunta.component.scss']
})
export class PreguntaFormComponent implements AfterViewInit {
    consulta!: boolean;
    @ViewChild('relacionpregunta') private relacionpregunta!: RelacionPreguntaComponent;
    public entidad: Pregunta;
    @Input() accion!: {accionid: number, accion: string};
    @Input() id!: number;
    @Output() output = new EventEmitter();

    cambio: boolean = false;
    public abierto!: boolean;
    public abiertopreguntaabierta!: boolean;
    public errorActivo!: boolean;

    SelCompetencia: any[];
    SelEscalaevaluacionvalor: any[];
    SelCriterio: any[];
    SelTipoPregunta: any[];
    SelTipoColaborador: any[];
    SelDepartamento: any[];
    SelNivel: any[];
    SelTodosNivel: any[] = [];
    SelEvaluador: any[];
    SelEscalaevaluacion: any[];
    SelPuesto: any[];

    dataTable: Array<any>;
    listpreguntaabierta: Array<any>;

    EliminarPregunta: any[];

    visible: boolean = true;
    ver: boolean;
    cancelarinervalo: boolean;

    DataEscalaevaluacionvalorid!: number;
    escalaevaluacion!: number;

    previapregunta: any;
    inter:any;
    filtro: any;


    constructor(private appService: AppService, private location: LocationStrategy, public sistemaService: SistemaService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver) {
        this.entidad = new Pregunta();

        this.SelCompetencia = [];
        this.SelCriterio = [];
        this.SelTipoPregunta = [];
        this.SelTipoColaborador = [];
        this.SelDepartamento = [];
        this.SelNivel = [];
        this.SelEscalaevaluacionvalor = [];
        this.SelEvaluador = [];
        this.SelEscalaevaluacion = [];
        this.SelPuesto = [];

        this.previapregunta = [];
        this.dataTable = [];
        this.listpreguntaabierta = [];
        this.EliminarPregunta = [];

        this.filtro = {};

        this.ver = false;
        this.cancelarinervalo = true;

        history.pushState(null, "", window.location.href);
        this.location.onPopState(() => {
            this.Salir();
        });
    }
    ngOnDestroy(): void {
        this.limpiarintervalo();
    }

    ngAfterViewInit() {
        if (this.accion.accionid == 2) {
            this.errorActivo = false;
            this.cancelarinervalo = false;
            this.ver = true;
            this.SetPreguntaEdit(this.id);
        }
        else if (this.accion.accionid == 3) {
            this.cancelarinervalo = false;
            this.SetPreguntaEdit(this.id);
        }
        if (this.accion.accionid == 1) {
            this.inter = setInterval(() => {
                if (this.cancelarinervalo) {
                    this.SetUltimaPregunta()
                } else {
                    this.limpiarintervalo();
                }
            }, 10000);
            this.SetUltimaPregunta();
            this.SetNivel();
        }

        this.SetCompetencia();
        this.SetTipoPregunta();

    }

    limpiarintervalo(){
        clearInterval(this.inter);
        this.inter = null;
    }

    //Funcion que obtiene la preugnta que se va a editar o visualizar
    SetPreguntaEdit(id: number) {
        this.appService.Get("planeacion/pregunta/" + id).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SetCriterio(res.data.competenciaid);
                this.SetEscalaEvaluacion(res.data.tipopreguntaid);
                this.SetEscalaEvaluacionValor(res.data.escalaevaluacionid);
                this.SetNivelPregunta(this.id).then(res => this.SetNivel());
                this.entidad = new Pregunta(res.data);
                this.previapregunta = res.data;
                if (res.data.relacionado == true) {
                    this.SetPreguntaRelacionada(res.data.preguntaid, res.data.escalaevaluacionid)
                    this.abierto = true;
                    this.errorActivo = false;
                }
            }
        });

    }

    //Trae las competencias para la creacion de la pregunta
    SetCompetencia() {
        this.appService.Post("configuracion/competencia/buscar", {activo: 1}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelCompetencia = res.data;
            }
        });
    }

    //Trae las tipo de pregunta para la creacion de la pregunta
    SetTipoPregunta() {
        this.appService.Get("catalogo/tipopregunta").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelTipoPregunta = res.data;
                if (!this.sistemaService.permisos.edicionespecial && this.accion.accionid != 2) {
                    this.SelTipoPregunta.splice(1, 1)
                }
            }
        });
    }

    //Funcion que obtiene los niveles para la pregunta
    SetNivel() {
        this.appService.Get("catalogo/nivel").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelNivel = res.data;
                this.SelTodosNivel = res.data;
            }
        });
    }

    //Funcion que trae la lista de niveles que tiene la pregunta
    SetNivelPregunta(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.appService.Get("catalogo/nivel/" + id).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    for (let valor of res.data) {
                        this.entidad.nivelid.push(valor.nivelid)
                    }
                    resolve({})
                }
            });
        })

    }

    //Funcion para obtener la escala de evaluacion dependiendo del tipo de pregunta seleccionado
    SetEscalaEvaluacion(tipodepreguntaid: number) {
        if (tipodepreguntaid == 1) {
            this.abiertopreguntaabierta = false;
            this.appService.Post("configuracion/escalaevaluacion/buscar", {activo: 1}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelEscalaevaluacion = res.data;
                    this.visible = true;
                }
            });
        }
        else if (tipodepreguntaid == 2) {
            this.SelEscalaevaluacion = [];
            this.entidad.escalaevaluacionid = 0;
            this.SelEscalaevaluacionvalor = [];
            this.visible = false;
            this.abiertopreguntaabierta = true;
            if(this.id != 0){
                this.SetPreguntaRelacionada(this.id);
            }
        }
        else {
            this.SelEscalaevaluacion = [];
            this.SelEscalaevaluacionvalor = [];
            this.entidad.escalaevaluacionid = 0;
            this.visible = false;
            this.abiertopreguntaabierta = false;
        }
    }

    SetUltimaPregunta(){
            this.appService.Post("planeacion/pregunta/ultimo", {}, [HeaderEnum.NoShowLoading]).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    if (res.data.clave == null) {
                        this.entidad.clave = 1
                    }
                    else if (this.entidad.clave == 0) {
                        this.entidad.clave = res.data.clave + 1
                    }
                    else if (this.entidad.clave == res.data.clave && this.cancelarinervalo) {
                        this.entidad.clave = res.data.clave + 1
                        this.mensajeService.Alerta(AlertaEnum.Warning, "La clave que tienes ya fue utilizada por otra pregunta, se te asigno la siguiente clave: " + this.entidad.clave);
                    }
                    else if(this.entidad.clave - 1 > res.data.clave && this.cancelarinervalo){
                        this.entidad.clave = res.data.clave + 1
                        this.mensajeService.Alerta(AlertaEnum.Warning, "La clave que tienes ya fue utilizada por otra pregunta, se te asigno la siguiente clave: " + this.entidad.clave);
                    }
                }
            })
    }

    //Filtrar la data de las preguntas relacionadas para imprimirlas en sus tablas correspondientes
    filtrarinfo(escalaevaluacionvalorid: number) {
        for (let valor of this.dataTable.filter(dato => dato.escalaevaluacionvalorid == escalaevaluacionvalorid)) {
            return valor.preguntas
        }
    }

    onContentReady(e: any) {
        if (e.component.totalCount() == 0) {
            e.component.option("height", '60');
        } else {
            e.component.option("height", 'auto');
        }
    }

    //Funcion para sacar la escala de evaluacion valor basando en la escala de evaluacion seleccionada
    SetEscalaEvaluacionValor(escalaevaluacionid: number) {
        this.dataTable = [];
        if (escalaevaluacionid) {
          if(escalaevaluacionid == 2){
            this.SelNivel = this.SelNivel.filter(x=>x.nivelid == 1 || x.nivelid == 2);
          }
            this.appService.Get("configuracion/escalaevaluacion/valor/" + escalaevaluacionid).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelEscalaevaluacionvalor = res.data;
                    if (this.previapregunta.preguntaid) {
                        this.SetPreguntaRelacionada(this.previapregunta.preguntaid, escalaevaluacionid)
                    }
                    this.escalaevaluacion = escalaevaluacionid
                }
            })
        } else {
          this.SelNivel = this.SelTodosNivel;
            this.SelEscalaevaluacionvalor = [];
        }
    }

    //Funcion para obtener las preguntas relacionadas con la pregunta padre
    SetPreguntaRelacionada(preguntapadreid: number, escalaevaluacion: number = 0): Promise<any> {
        return new Promise((resolve, reject) => {
            this.appService.Post("planeacion/pregunta/relacionpregunta", {escalaevaluacionid: escalaevaluacion, preguntapadreid: preguntapadreid}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    if (escalaevaluacion == 0) {
                        this.listpreguntaabierta = res.data[0]?.preguntas;
                    } else {
                        this.dataTable = res.data;
                    }
                    resolve({datatable: res.data})
                }
            });
        })
    }

    //Funcion que obtiene el criterio dependiendo de la competenecia seleccionada
    SetCriterio(competenciaid: number) {
        if (competenciaid) {
            this.appService.Post("configuracion/criterio/buscar", {competenciaid: competenciaid, activo: 1}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.SelCriterio = res.data;
                }
            });
        } else {
            this.entidad.criterioid = 0
            this.SelCriterio = [];
        }
    }

    //Salir del formulario
    Salir() {
        this.cancelarinervalo = false;
       this. limpiarintervalo();
        this.output.next(this.cambio);
    }

    //Eliminar la pregunta relacionada seleccionada
    Eliminar(pregunta: any, escalavalor: number = 0) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                if (escalavalor != 0) {
                    for (let valor of this.dataTable.filter(dato => dato.escalaevaluacionvalorid == escalavalor)) {
                        this.EliminarPregunta = valor.preguntas
                        this.EliminarPregunta.forEach((element, index) => {
                            if (element.preguntaid == pregunta.preguntaid) {
                                this.appService.Delete("planeacion/pregunta/preguntarelacion/" + element.preguntarelacionid).then(res => {
                                    if (res.status == RespuestaEstatusEnum.Success) {
                                        this.EliminarPregunta.splice(index, 1);
                                        valor.preguntas = this.EliminarPregunta
                                    }
                                })
                            }
                        })
                    }
                } else {
                    this.appService.Delete("planeacion/pregunta/preguntarelacion/" + pregunta.preguntarelacionid).then(res => {
                        if (res.status == RespuestaEstatusEnum.Success) {
                            this.listpreguntaabierta.forEach((element, index) => {
                                if (pregunta.preguntaid == element.preguntaid) {
                                    this.listpreguntaabierta.splice(index, 1);

                                }
                            })
                        }
                    })
                }
            }
        })


    }

    //Funcion que se utiliza para obtener el id de la pregunta padre para relacionar preguntas al momento de crear por primera vez una pregunta
    GuardarParaRelacionar(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.errorActivo = true;
            let respuesta = this.Validar();
            if (respuesta != true) {
                return this.mensajeService.Alerta(AlertaEnum.Warning, respuesta);
            }
            let data = new Pregunta(this.entidad)
            this.appService.Post("planeacion/pregunta", data).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.id = res.data.id;
                    this.entidad.preguntaid = this.id;
                    this.cancelarinervalo = false
                    this.limpiarintervalo();
                    resolve({preguntapadreid: this.id})
                }
            });
        });
    }

    //Guardar una nueva pregunta o editando una pregunta que ya existe
    Guardar() {
        let respuesta = this.Validar();
        if (respuesta === true) {
                let data = new Pregunta(this.entidad)
                    this.appService.Post("planeacion/pregunta", data).then(res => {
                        if (res.status == RespuestaEstatusEnum.Success) {
                            this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                            this.cambio = true
                            this.cancelarinervalo = false
                            this.limpiarintervalo();
                            this.output.next(this.cambio);
                        }
                    });
        }else {
            this.mensajeService.Alerta(AlertaEnum.Warning, this.Validar())
        }
    }

    //Funcion que valida que la pregunta va a ser relacionada a otras preguntas y obteniendo la lista de preguntas relacionadas en caso de que las tenga
    TablaRelacionadas(valor: boolean) {
        if (valor == true) {
            if (this.entidad.tipopreguntaid == 1) {
                if (this.escalaevaluacion && this.previapregunta.preguntaid) {
                    this.SetPreguntaRelacionada(this.previapregunta.preguntaid, this.escalaevaluacion)
                }
            }
            this.abierto = true;
            this.errorActivo = false;
        } else {
            this.abierto = false;

        }
    }

    //Funcion para generar el filtro base para la busquedas de preguntas para relacionar
    Formulario(escalaevaluacionvalorid: number) {
        this.DataEscalaevaluacionvalorid = escalaevaluacionvalorid;
        this.filtro = {'departamento': this.previapregunta.departamento, 'puesto': this.previapregunta.puesto, 'nivel': this.previapregunta.nivel, 'nivelid': this.entidad.nivelid, 'tipocolaborador': this.previapregunta.tipocolaborador}
        this.Agregarpreguntarelacion({filtro: this.filtro, escalaevaluacionvalorid: escalaevaluacionvalorid});
    }

    //Funcion para generar el filtro base para la busqueda de preguntas para relacionar con tipo de pregunta abierta
    Formularioabierta() {
        this.filtro = {'departamento': this.previapregunta.departamento, 'puesto': this.previapregunta.puesto, 'nivel': this.previapregunta.nivel, 'nivelid': this.entidad.nivelid, 'tipocolaborador': this.previapregunta.tipocolaborador}
        this.Agregarpreguntarelacion({filtro: this.filtro, escalaevaluacionvalorid: 0});
    }

    //Funcion que valida los datos obligatorios en el formulario para la creacion de nueva pregunta
    Validar(): any {
        this.errorActivo = true;
        if (!this.entidad.competenciaid) {
            return "Se tiene que seleccionar una competencia";
        }
        if (!this.entidad.criterioid) {
            return "Se tiene que seleccionar un criterio";
        }
        if (!this.entidad.tipopreguntaid) {
            return "Se tiene que seleccionar un tipo de pregunta";
        }
        if (this.entidad.tipopreguntaid == 1) {
            if (!this.entidad.escalaevaluacionid) {
                return "Se tiene que seleccionar una escala de evaluación"
            }
        }
        if (!this.entidad.autoevaluacion && this.entidad.mostrarautoevaluacion) {
            return "Se requiere escribir la pregunta de auto evaluación";
        }
        if (!this.entidad.pregunta){
            return "Se requiere escribir la pregunta"
        }
        return true
    }

    //Funcion que activa el modal para ver las preguntas que se pueden relacionar a la pregunta padre validando informacion y obtener la estructura base para guardar las preguntas relacionadas
    Agregarpreguntarelacion(data: {filtro: any, escalaevaluacionvalorid: number}) {
        this.relacionpregunta.entidad.nivelid = this.entidad.nivelid;
        this.relacionpregunta.BlockNivel = true;
        this.relacionpregunta.BlockTipoColaborador = true;
        this.relacionpregunta.BlockDepartamento = true;
        this.relacionpregunta.BlockPuesto = true;
        this.relacionpregunta.Blockrelacion = true;
        this.relacionpregunta.cargarbusqueda = true;
        this.relacionpregunta.quitarrelacionados = true;
        for (let infopreguntas of this.dataTable) {
            if (infopreguntas.escalaevaluacionvalorid == data.escalaevaluacionvalorid) {
                for (let pregunta of infopreguntas.preguntas) {
                    this.relacionpregunta.PreguntasYaSeleccionadas.push(pregunta.preguntaid)
                }
            }
        }
        if (this.id) {
            this.relacionpregunta.Modal(this.id);
        } else {
            if (this.entidad.tipopreguntaid == 2) {
                this.GuardarParaRelacionar().then(res => this.SetPreguntaRelacionada(this.id).then(res => this.relacionpregunta.Modal(this.id)));
            } else {
                this.GuardarParaRelacionar().then(res => this.SetPreguntaRelacionada(this.id, this.entidad.escalaevaluacionid).then(res => this.relacionpregunta.Modal(this.id)));
            }
        }
    }

    //Funcion que guarda las preguntas relacionadas a la pregunta padre
    GuardarPreguntaRelacion(datarelacion: any[]) {
        let preguntarelacion = [];
        let info = {}
        for (let infoactual of this.dataTable) {
            if (infoactual.preguntas.length > 0) {
                for (let pregunta of infoactual.preguntas) {
                    info = {'preguntapadreid': this.id, 'escalaevaluacionvalorid': infoactual.escalaevaluacionvalorid, 'preguntaid': pregunta.preguntaid}
                    preguntarelacion.push(info);
                }
            }
        }
        if (datarelacion.length != 0) {
            if (this.DataEscalaevaluacionvalorid) {
                for (let preguntaid of datarelacion) {
                    info = {'preguntapadreid': this.id, 'escalaevaluacionvalorid': this.DataEscalaevaluacionvalorid, 'preguntaid': preguntaid}
                    preguntarelacion.push(info);
                }
                let datapreguntasrelacion = {'preguntaid': this.id, 'listpregunta': preguntarelacion}
                this.appService.Post("planeacion/pregunta/preguntarelacion", datapreguntasrelacion).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.relacionpregunta.CerrarModal()
                        this.SetPreguntaRelacionada(this.id, this.entidad.escalaevaluacionid)
                    }
                });
            } else {
                for (let preguntaid of datarelacion) {
                    info = {'preguntapadreid': this.id, 'escalaevaluacionvalorid': 0, 'preguntaid': preguntaid}
                    preguntarelacion.push(info);
                }
                let datapreguntasrelacion = {'preguntaid': this.id, 'listpregunta': preguntarelacion}
                this.appService.Post("planeacion/pregunta/preguntarelacion", datapreguntasrelacion).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.relacionpregunta.CerrarModal();
                        this.SetPreguntaRelacionada(this.id);
                    }
                });
            }
        }
    }

    cargartexto(e:any){
        if(e && this.entidad.pregunta && !this.entidad.autoevaluacion){
            this.entidad.autoevaluacion = this.entidad.pregunta;
        }
    }
}
